<h2>Sage</h2>
<div class="flex flex-row space-x-12">
  <app-key-value-pair name="Status" value="{{ status$ | async | titlecase }}" />
  <button
    mat-flat-button
    color="primary"
    (click)="attemptConnection()"
    *ngIf="(status$ | async) !== 'connected'; else options"
  >
    Connect to Sage
  </button>
  <ng-template #options>
    <button
      mat-flat-button
      color="warn"
      (click)="disconnectConfirm()"
      [disabled]="loading$ | async"
    >
      Disconnect
    </button>
    <button
      mat-flat-button
      (click)="openAccountSetupDialog()"
      [disabled]="loading$ | async"
    >
      Account / Tax Mappings
    </button>
    <button
      mat-flat-button
      (click)="importCustomers()"
      [disabled]="loading$ | async"
    >
      Import Customers
    </button>
  </ng-template>
</div>
